/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var definitions = require('./definitions.cjs');

function normalize(configComponent, compilationContext) {
  return definitions.normalizeComponent(configComponent, compilationContext);
}

exports.normalize = normalize;
